<div class="mars-tutorization__body" (paste)="onPaste($event)">
  <div class="mars-tutorization__head">
    <div class="mars-tutorization__title">
      <span>{{ 'actions.createQuestionsList' | translate }}</span>
      <gl-tooltip posbottom [text]="'actions.createQuestionsTooltip' | translate"></gl-tooltip>
    </div>
    <div class="mars-tutorization__text mandatory" [innerHtml]="'nouns.mandatory' | translate"></div>
  </div>
  <div class="gl-table__toolbar">
    <span class="text">{{ dataSource.docs.length }} elementos</span>
    <gl-button
      color-tertiary
      icon-left="glicon-plus-circle"
      [text]="'actions.createQuestion' | translate"
      (onClick)="createEmptyRow()"
    ></gl-button>
  </div>
  <div class="gl-table__container">
    <div *ngIf="selectable && isAnySelected">
      <div class="lms-toolbar__secondary" [ngClass]="{ hidden: !isAnySelected }" tools-actions>
        <div class="list-counter">
          <span>
            {{ isHeaderSelectedAll ? dataSource.docs.length - excludedQuestions.size : selectedQuestions.length }}
            {{
              (selectedQuestions.length === 1 ? 'documents.questions.selectedSingle' : 'documents.questions.selected')
                | translate
            }}
          </span>
          <a
            (click)="setSelectAll(true)"
            *ngIf="!isHeaderSelectedAll"
            title="{{ 'documents.questions.selectAll' | translate : { total: dataSource.docs.length } }}"
            >{{ 'documents.questions.selectAll' | translate : { total: dataSource.docs.length } }}
          </a>
        </div>
        <div class="actions">
          <a
            (click)="deleteBulk(selectedQuestions)"
            title="{{ 'actions.delete' | translate }}"
            class="margin-half-right"
          >
            {{ 'actions.delete' | translate }}
          </a>
          <div class="border-left padding-left margin-left-8">
            <gl-button
              color-secondary
              small
              [text]="'actions.cancelSelection' | translate"
              (onClick)="setSelectAll(false)"
            >
            </gl-button>
          </div>
        </div>
      </div>
    </div>
    <gl-table-header
      [columns]="dataSource.columns"
      rowIndex
      [attr.disableHeaderSelector]="isHeaderSelectedAll ? true : null"
      [attr.selectable]="selectable ? true : null"
      (onSelectionChanged)="setSelectHeader($event.detail.selected)"
    ></gl-table-header>
    <div class="gl-table__scroll marsQuestions">
      <gl-table
        #questionsTable
        data-testid="groupQuestionsEditorList"
        [dataSource]="dataSource"
        [placeholder]="'actions.noResultTable' | translate"
        rowIndex
        basicMode
        [attr.disableHeaderSelector]="isHeaderSelectedAll ? true : null"
        [attr.selectable]="selectable ? true : null"
        (onSelectionChanged)="onSelectionChanged($event.detail)"
      >
        <div slot="header"></div>
      </gl-table>
    </div>
    <div class="gl-table__buttons">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="cancelClicked()"> </gl-button>
      <gl-button
        color-primary
        [disabled]="saveDisabled"
        [text]="'actions.createQuestions' | translate"
        (onClick)="save()"
      ></gl-button>
    </div>
  </div>
</div>
